import { render, staticRenderFns } from "./checkboxGroup.vue?vue&type=template&id=6567ed0a"
import script from "./checkboxGroup.vue?vue&type=script&lang=js"
export * from "./checkboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports